import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";

import { ServicePO } from "../../../_models/table-models";
import { AuthService } from "src/app/_app-core/services/auth/auth.service";
import { PosService } from "src/app/_services/posService";

@Component({
    selector: "app-proof-of-delivery-service",
    templateUrl: "./proof-of-delivery-service.component.html",
    styleUrls: ["./proof-of-delivery-service.component.scss"],
})
export class ProofOfDeliveryServiceComponent implements OnInit {
    searchTerm: string = "";
    responseData: any;
    isError: any;
    isEmpty = false;
    poNo: any;
    poService: ServicePO[] = [];
    selectedItems = [];
    loading = true;
    all = false;
    isSelected = false;
    displayName: any;
    page = 1;
    pageSize = 10;
    collectionSize: any;
    po: any;
    sessionExpired = false;
    errorMsg = "";
    isCondensed: boolean = false;
    currentLayout = {
        isCondensed: true,
    };
    selectedOption = false;
    filterBy: any;
    impersonate;

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private posService: PosService,
        private authService: AuthService
    ) {}

    toggleSidebar() {
        this.currentLayout.isCondensed = !this.currentLayout.isCondensed;
        document.body.setAttribute(
            "data-sidebar-size",
            this.currentLayout.isCondensed ? "condensed" : "default"
        );
    }

    ngOnInit(): void {
        this.displayName = localStorage.getItem("displayName");
        this.poNo = this.route.snapshot.params["poNo"];
        if (
            localStorage.getItem("impersonation") === null ||
            localStorage.getItem("impersonation") === ""
        ) {
            this.impersonate = "false";
        } else {
            this.impersonate = localStorage.getItem("impersonation");
        }

        const userData = {
            poNumber: this.poNo,
            action: "get",
            sellerCode: localStorage.getItem("vendorCode"),
            session: { sessionId: localStorage.getItem("userSession") },
        };

        this.posService.fetchPurchaseOrders(userData).subscribe(
            (res) => {
                this.loading = false;
                this.responseData = res;
                //console.log(res);
                //console.log(this.responseData);
                if (this.responseData.length !== 0) {
                    //console.log('You did it');
                    localStorage.setItem(
                        "servCompanyCode",
                        this.responseData.pos[0].po_company_code
                    );
                    localStorage.setItem(
                        "servPurchaseOrg",
                        this.responseData.pos[0].po_purchase_org
                    );
                    localStorage.setItem(
                        "servDocType",
                        this.responseData.pos[0].po_doc_type
                    );
                    this.poService = this.responseData.pos[0].line_items.map(
                        (r: any) => ({
                            checked: false,
                            ...r,
                        })
                    );
                    this.collectionSize =
                        this.responseData.pos[0].line_items.length;
                    this.refreshPo();
                    //console.log(this.poService);
                } else {
                    this.isEmpty = true;
                    //console.log('Error Here');
                }
                //console.log(res);
            },
            (error) => {
                if (error.status === 401) {
                    this.sessionExpired = true;
                    this.errorMsg = error.error.msg;
                    this.loading = false;
                }
            }
        );
    }

    accountLogout() {
        const userData = {
            session: { sessionId: localStorage.getItem("userSession") },
        };
        this.authService.logOut(userData).subscribe(
            (res) => {
                const responseData: any = res;
                if (responseData.status === "ok") {
                    localStorage.clear();
                    this.router.navigateByUrl("/");
                }
            },
            (error) => {
                console.log(error);
            }
        );
    }

    checkAll(ev: any) {
        this.po.forEach((x: any) => {
            x.checked = ev.target.checked;
            this.onCheckboxChange(x.id - 1); // Manually call the handler for each checkbox
        });
    }

    isAllCheck() {
        return this.po.every((p: any) => p.checked);
    }

    onCheckboxChange(index: number) {
        const isChecked = this.po[index].checked;

        if (isChecked) {
            // Check if the item is already in the selectedItems array
            const exists = this.selectedItems.some(
                (item) => item.id === this.po[index].id
            );

            // Only add the item if it's not already in the array
            if (!exists) {
                this.selectedItems.push(this.po[index]);
            }
        } else {
            // Remove the item from selectedItems array if unchecked
            const selectedIndex = this.selectedItems.findIndex(
                (item) => item.id === this.po[index].id
            );
            if (selectedIndex !== -1) {
                this.selectedItems.splice(selectedIndex, 1);
            }
        }

        this.isSelected = this.selectedItems.length !== 0;
    }

    sendPo(po = null) {
        if (po !== null) {
            console.log(po + " this is the null value");
        } else {
            if (this.selectedItems.length !== 0) {
                const items = this.selectedItems.map((r: any) => ({
                    ...r,
                    po_no: this.poNo,
                    grn_no: "",
                }));

                localStorage.setItem("pods", JSON.stringify(items));
                this.router.navigate(["/submit-invoice", this.poNo]);
            }
        }
    }

    refreshPo() {
        let sortedLineItem = this.poService.sort((a, b) =>
            a.po_item_line > b.po_item_line ? 1 : -1
        );
        this.po = sortedLineItem
            .map((po: any, i: any) => ({
                id: i + 1,
                ...po,
                checked: this.selectedItems.some(
                    (selected: any) => selected.id === i + 1
                ),
            }))
            .slice(
                (this.page - 1) * this.pageSize,
                (this.page - 1) * this.pageSize + this.pageSize
            );
    }

    onFilter(option: any) {
        this.filterBy = option.target.value;
        console.log(this.filterBy + " option selected");
        this.selectedOption = true;
    }

    onSearch(event: KeyboardEvent) {
        this.searchTerm = (event.target as HTMLInputElement).value;
        if (this.searchTerm !== "") {
            if (this.filterBy === "po_item_description") {
                this.po = this.poService.filter((data) =>
                    (data.po_item_description as string)
                        .toLowerCase()
                        .includes(this.searchTerm.toLowerCase())
                );
            } else {
                this.po = this.poService.filter((data) =>
                    data.po_item_line
                        .toString()
                        .toLowerCase()
                        .includes(this.searchTerm.toLowerCase())
                );
            }
        } else {
            this.po = this.poService;
        }
    }

    generalSearch(event: KeyboardEvent) {
        this.searchTerm = (event.target as HTMLInputElement).value;

        if (this.searchTerm !== "") {
            this.po = this.poService.filter(
                (data) =>
                    (data.po_item_description as string)
                        .toLowerCase()
                        .includes(this.searchTerm.toLowerCase()) ||
                    data.po_item_line
                        .toString()
                        .toLowerCase()
                        .includes(this.searchTerm.toLowerCase())
            );
        } else {
            this.po = this.poService;
        }
    }
}
